import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

/**
 * Fetches the list of vendor invoices for the current user
 * @returns {Promise} - API response containing list of invoices
 */
export const getVendorInvoices = async () => {
  try {
    const response = await apiClient.get('/vendorInvoiceManagement/invoice/list');

    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
